import { createApi } from '@reduxjs/toolkit/query/react'
import { CREATE_SCHOOL, LIST_SCHOOL, REMOVE_SCHOOL, RESEND_CLIENT_REPORT, UPDATE_SCHOOL, VIEW_SCHOOL } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { schoolDivisonsApi } from "./schoolsDivisons"
import { invalidateAPITags } from "utils/common"

export const schoolsApi = createApi({
  reducerPath: 'schoolsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/school",
  }),
  tagTypes: ["Schools"],
  endpoints: (builder) => ({
    // get Schools list
    getSchoolList: builder.query({
      query: ({ search = "", status = "", page = 1, limit = 10, division = "", sort = { column: "name", direction: "ASC" } }) => {
        return ({
          method: "PATCH",
          url: LIST_SCHOOL,
          data: {
            search,
            status,
            page,
            limit,
            division: division,
            sort,
          },
        })
      },
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["Schools"]
    }),

    // get School profile
    getSchoolData: builder.query({
      query: (id) => ({
        method: "GET",
        url: `${VIEW_SCHOOL}/${id}`
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["Schools"]
    }),

    // create School profile
    createSchool: builder.mutation({
      query: (data) => ({
        method: "POST",
        url: CREATE_SCHOOL,
        data
      }),
      invalidatesTags: ["Schools"],

      // Invalidates school divisions lookup in utility api
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        invalidateSchoolDivisions(queryFulfilled, dispatch);
      }
    }),

    // update School profile
    updateSchool: builder.mutation({
      query: (data) => ({
        method: "PUT",
        url: `${UPDATE_SCHOOL}/${data.id}`,
        data: data.payload
      }),
      invalidatesTags: ["Schools"],

      // Invalidates school divisions lookup in utility api
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        invalidateSchoolDivisions(queryFulfilled, dispatch);
      },
    }),

  
    // delete School profile
    deleteSchool: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `${REMOVE_SCHOOL}/${id}`
      }),
      invalidatesTags: ["Schools"],

      // Invalidates school divisions lookup in utility api
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        invalidateAPITags(queryFulfilled, dispatch);
      }
    }),
  }),
})

const invalidateSchoolDivisions = (queryFulfilled, dispatch) => {
  invalidateAPITags(queryFulfilled, dispatch, schoolDivisonsApi, ["SchoolDivisonLookup"]);
}

export const {
  useGetSchoolListQuery,
  useCreateSchoolMutation,
  useGetSchoolDataQuery,
  useUpdateSchoolMutation,
  useDeleteSchoolMutation,
  useLazyGetSchoolListQuery, 
} = schoolsApi;